// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header Component Styles */
.header .controls {
  margin-left: auto;
}

.header-logo-link {
  text-decoration: none;
}

.header-site-nav {
  display: flex;
  align-items: center;
  gap: 24px;
  list-style: none;
  margin: 0 12px;
  padding: 0;
}

.header-site-nav-link {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #8a8578;
  text-decoration: none;
  transition: color 0.2s ease;
}

.header-site-nav-link:hover {
  color: #c9a227;
}

.header-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-user-link {
  text-decoration: none;
  color: inherit;
}

.header-user-display {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 13px;
  color: #d4a574;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 3px;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.header-user-display:hover {
  background: rgba(212, 165, 116, 0.1);
  color: #e8c594;
}

.header-nav-link {
  text-decoration: none;
}

.header-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(212, 165, 116, 0.2);
  border-top-color: #d4a574;
  border-radius: 50%;
  animation: loading-spin 1s linear infinite;
  margin-right: 8px;
}

/* ===== Landing page header overrides ===== */
.header--landing {
  background: rgba(17, 17, 17, 0.95);
  border: none;
  border-radius: 0;
  box-shadow: none;
  margin-bottom: 0;
  padding: 16px 48px;
}

.header--landing::before {
  display: none;
}

.header--landing .app-title {
  color: #e8e4dc;
  font-size: 14px;
  letter-spacing: 3px;
}

.header--landing .header-site-nav {
  gap: 32px;
}

.header--landing .header-site-nav-link {
  color: #c0c0c0;
  font-size: 14px;
  font-weight: 400;
}

.header--landing .header-site-nav-link:hover {
  color: #ffffff;
}

.landing-get-started-btn {
  background: linear-gradient(180deg, #4a9c6d 0%, #3d8259 100%);
  color: #fff !important;
  border: 1px solid #3d8259;
  border-radius: 30px;
  padding: 10px 24px;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  box-shadow: 0 2px 8px rgba(74, 156, 109, 0.2);
  transition: all 0.2s ease;
}

.landing-get-started-btn:hover {
  background: linear-gradient(180deg, #5aac7d 0%, #4a9269 100%);
  box-shadow: 0 4px 20px rgba(74, 156, 109, 0.35);
  transform: translateY(-1px);
}

/* ===== Landing mobile hamburger menu ===== */
.landing-mobile-menu {
  display: none;
  position: relative;
}

.landing-hamburger-btn {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 26px;
  height: 20px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1001;
  position: relative;
}

.landing-hamburger-btn:focus-visible {
  outline: 2px solid #4a9c6d;
  outline-offset: 4px;
  border-radius: 2px;
}

.landing-hamburger-line {
  width: 100%;
  height: 2px;
  background-color: #c0c0c0;
  border-radius: 2px;
  transition: all 0.3s ease;
  transform-origin: center;
}

.landing-hamburger-btn:hover .landing-hamburger-line {
  background-color: #fff;
}

.landing-hamburger-btn.open .landing-hamburger-line:nth-child(1) {
  transform: rotate(45deg) translate(6px, 6px);
}

.landing-hamburger-btn.open .landing-hamburger-line:nth-child(2) {
  opacity: 0;
}

.landing-hamburger-btn.open .landing-hamburger-line:nth-child(3) {
  transform: rotate(-45deg) translate(6px, -6px);
}

.landing-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}

.landing-menu-dropdown {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 8px;
  list-style: none;
  margin: 0;
  padding: 4px 0;
  min-width: 180px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  z-index: 1000;
  animation: landingMenuFadeIn 0.15s ease;
}

@keyframes landingMenuFadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.landing-menu-item {
  display: block;
  padding: 12px 20px;
  text-decoration: none;
  color: #c0c0c0;
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 15px;
  font-weight: 400;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.landing-menu-item:hover,
.landing-menu-item:focus {
  background-color: #252525;
  color: #fff;
  outline: none;
}

.landing-menu-cta {
  color: #fff;
  font-weight: 600;
  background: linear-gradient(180deg, #4a9c6d 0%, #3d8259 100%);
  margin: 4px 8px 8px;
  border-radius: 8px;
  text-align: center;
}

.landing-menu-cta:hover,
.landing-menu-cta:focus {
  background: linear-gradient(180deg, #5aac7d 0%, #4a9269 100%);
  color: #fff;
}

/* ===== Landing header responsive ===== */
@media (max-width: 768px) {
  .header--landing {
    padding: 14px 20px;
  }

  .header--landing .app-title {
    font-size: 13px;
    letter-spacing: 2px;
  }

  /* Hide desktop nav, show hamburger */
  .header--landing .landing-nav-desktop {
    display: none;
  }

  .header--landing .landing-mobile-menu {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/client/components/Header.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;EACE,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,6DAA6D;EAC7D,WAAW;AACb;;AAEA,0CAA0C;AAC1C;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA,qCAAqC;EACrC;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Header Component Styles */\n.header .controls {\n  margin-left: auto;\n}\n\n.header-logo-link {\n  text-decoration: none;\n}\n\n.header-site-nav {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  list-style: none;\n  margin: 0 12px;\n  padding: 0;\n}\n\n.header-site-nav-link {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #8a8578;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.header-site-nav-link:hover {\n  color: #c9a227;\n}\n\n.header-user-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.header-user-link {\n  text-decoration: none;\n  color: inherit;\n}\n\n.header-user-display {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 13px;\n  color: #d4a574;\n  cursor: pointer;\n  padding: 6px 12px;\n  border-radius: 3px;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.header-user-display:hover {\n  background: rgba(212, 165, 116, 0.1);\n  color: #e8c594;\n}\n\n.header-nav-link {\n  text-decoration: none;\n}\n\n.header-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(212, 165, 116, 0.2);\n  border-top-color: #d4a574;\n  border-radius: 50%;\n  animation: loading-spin 1s linear infinite;\n  margin-right: 8px;\n}\n\n/* ===== Landing page header overrides ===== */\n.header--landing {\n  background: rgba(17, 17, 17, 0.95);\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  margin-bottom: 0;\n  padding: 16px 48px;\n}\n\n.header--landing::before {\n  display: none;\n}\n\n.header--landing .app-title {\n  color: #e8e4dc;\n  font-size: 14px;\n  letter-spacing: 3px;\n}\n\n.header--landing .header-site-nav {\n  gap: 32px;\n}\n\n.header--landing .header-site-nav-link {\n  color: #c0c0c0;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.header--landing .header-site-nav-link:hover {\n  color: #ffffff;\n}\n\n.landing-get-started-btn {\n  background: linear-gradient(180deg, #4a9c6d 0%, #3d8259 100%);\n  color: #fff !important;\n  border: 1px solid #3d8259;\n  border-radius: 30px;\n  padding: 10px 24px;\n  font-size: 13px;\n  font-weight: 700;\n  text-decoration: none;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  box-shadow: 0 2px 8px rgba(74, 156, 109, 0.2);\n  transition: all 0.2s ease;\n}\n\n.landing-get-started-btn:hover {\n  background: linear-gradient(180deg, #5aac7d 0%, #4a9269 100%);\n  box-shadow: 0 4px 20px rgba(74, 156, 109, 0.35);\n  transform: translateY(-1px);\n}\n\n/* ===== Landing mobile hamburger menu ===== */\n.landing-mobile-menu {\n  display: none;\n  position: relative;\n}\n\n.landing-hamburger-btn {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  width: 26px;\n  height: 20px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  z-index: 1001;\n  position: relative;\n}\n\n.landing-hamburger-btn:focus-visible {\n  outline: 2px solid #4a9c6d;\n  outline-offset: 4px;\n  border-radius: 2px;\n}\n\n.landing-hamburger-line {\n  width: 100%;\n  height: 2px;\n  background-color: #c0c0c0;\n  border-radius: 2px;\n  transition: all 0.3s ease;\n  transform-origin: center;\n}\n\n.landing-hamburger-btn:hover .landing-hamburger-line {\n  background-color: #fff;\n}\n\n.landing-hamburger-btn.open .landing-hamburger-line:nth-child(1) {\n  transform: rotate(45deg) translate(6px, 6px);\n}\n\n.landing-hamburger-btn.open .landing-hamburger-line:nth-child(2) {\n  opacity: 0;\n}\n\n.landing-hamburger-btn.open .landing-hamburger-line:nth-child(3) {\n  transform: rotate(-45deg) translate(6px, -6px);\n}\n\n.landing-menu-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n}\n\n.landing-menu-dropdown {\n  position: absolute;\n  top: calc(100% + 12px);\n  right: 0;\n  background: #1a1a1a;\n  border: 1px solid #333;\n  border-radius: 8px;\n  list-style: none;\n  margin: 0;\n  padding: 4px 0;\n  min-width: 180px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n  animation: landingMenuFadeIn 0.15s ease;\n}\n\n@keyframes landingMenuFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.landing-menu-item {\n  display: block;\n  padding: 12px 20px;\n  text-decoration: none;\n  color: #c0c0c0;\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 15px;\n  font-weight: 400;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.landing-menu-item:hover,\n.landing-menu-item:focus {\n  background-color: #252525;\n  color: #fff;\n  outline: none;\n}\n\n.landing-menu-cta {\n  color: #fff;\n  font-weight: 600;\n  background: linear-gradient(180deg, #4a9c6d 0%, #3d8259 100%);\n  margin: 4px 8px 8px;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.landing-menu-cta:hover,\n.landing-menu-cta:focus {\n  background: linear-gradient(180deg, #5aac7d 0%, #4a9269 100%);\n  color: #fff;\n}\n\n/* ===== Landing header responsive ===== */\n@media (max-width: 768px) {\n  .header--landing {\n    padding: 14px 20px;\n  }\n\n  .header--landing .app-title {\n    font-size: 13px;\n    letter-spacing: 2px;\n  }\n\n  /* Hide desktop nav, show hamburger */\n  .header--landing .landing-nav-desktop {\n    display: none;\n  }\n\n  .header--landing .landing-mobile-menu {\n    display: block;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
